export const DECORATIVE_ORDER_REQUEST = "DECORATIVE_ORDER_REQUEST";
export const DECORATIVE_ORDER_SUCCESS = "DECORATIVE_ORDER_SUCCESS";
export const DECORATIVE_ORDER_FAILED = "DECORATIVE_ORDER_FAILED";
